<!--Copyright (C) nexleader - All Rights Reserved-->
<!--Unauthorized copying of this file, via any medium is strictly prohibited-->
<!--Proprietary and confidential-->
<!--Written for nexleader <myipsat.com>, 2016-2026-->

<div class="modal-header">
  <h3 class="modal-title">Create Archetype Report Discount Code</h3>
  <button type="button" class="close" (click)="close()">
    <span>&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-12 m-b-md">
      <p>
        Users can apply this discount code when purchasing an IPSAT 2.0
        Archetype Report. Codes are case-insensitive.
      </p>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">Discount Code</label>
      <input
        type="text"
        placeholder="ARCHETYPE2026"
        class="form-control text-uppercase"
        [(ngModel)]="discount.name"
      />
      <small class="text-muted">This is what users will enter at checkout</small>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">Discount Type</label>
      <app-nexleader-input-enum
        [enumName]="'TeamReportDiscountTypes'"
        [model]="discount.discountType"
        (realOnChange)="discount.discountType = $event"
      ></app-nexleader-input-enum>
      <small class="text-muted">Flat Fee sets the price; Percentage reduces it</small>
    </div>
    <div class="form-group col-md-6" *ngIf="discount.discountType">
      <label class="control-label">
        Discount Amount ({{ getDiscountAmountSymbol() }})
      </label>
      <input
        type="number"
        placeholder="0"
        class="form-control"
        [(ngModel)]="discountAmountRaw"
      />
      <small class="text-muted" *ngIf="discount.discountType?.identifier === 'flat_fee'">
        Enter the final price (e.g., 0 for free, 29 for $29)
      </small>
      <small class="text-muted" *ngIf="discount.discountType?.identifier === 'percentage'">
        Enter the percentage off (e.g., 20 for 20% off)
      </small>
    </div>
    <div class="form-group col-md-6" *ngIf="discount.discountType">
      <label class="control-label">Max Uses (optional)</label>
      <input
        type="number"
        placeholder="Unlimited"
        class="form-control"
        [(ngModel)]="discount.maxUses"
      />
      <small class="text-muted">Leave blank for unlimited uses</small>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">Expires On (optional)</label>
      <input
        type="date"
        class="form-control"
        [(ngModel)]="discount.expiresAt"
      />
      <small class="text-muted">Leave blank for no expiration</small>
    </div>
    <div class="form-group col-md-12">
      <label>
        <input type="checkbox" [(ngModel)]="discount.onePerUser" />
        Once per user
      </label>
      <small class="text-muted d-block">
        When checked, the same code can be shared with multiple users but
        each user can only redeem it once. Combine with a high Max Uses
        cap to control total volume.
      </small>
    </div>
    <div class="form-group col-md-12">
      <label>
        <input type="checkbox" [(ngModel)]="discount.refreshOnly" />
        Refresh only
      </label>
      <small class="text-muted d-block">
        When checked, this code only applies to a post-coaching report
        <strong>refresh</strong> — it is rejected on new report purchases and
        1.0 upgrades. Use this for a free refresh code so it can't be used to
        get a full report for free.
      </small>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-default" type="button" (click)="close()">
    Cancel
  </button>
  <button class="btn btn-success" type="button" (click)="save()">
    Create Discount
  </button>
</div>
